/**
 * What the service decided about one activity before the picker rendered it.
 *
 * Everything but Importable is a row shown and not selectable. Showing the
 * refusal beats hiding the ride: a rider who cannot find yesterday's ride in
 * the list concludes the import is broken, where a rider who finds it marked
 * "already reported" has their answer.
 */
export enum ImportCandidateDisposition {
  Importable = "importable",
  AlreadyImported = "already_imported",
  OverlapsImportedRide = "overlaps_imported_ride",
  MatchesReportedRide = "matches_reported_ride",
  OutsideCampaignWindow = "outside_campaign_window",
  NotHumanPowered = "not_human_powered",
  MotorAssisted = "motor_assisted",
  NoDistance = "no_distance",
}
